/*
 * @Author: your name
 * @Date: 2020-11-12 21:02:06
 * @LastEditTime: 2020-11-12 21:02:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/utils/formatters.js
 */
/** 身份证号码格式 */
export const idcardMatching = {
  format(idcard) {
    idcard = idcard.toLocaleUpperCase();
    var city = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江 ",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 "
    };
    var pass = true;
    var reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/;
    if (!idcard || !reg.test(idcard)) {
      pass = false;
    } else if (!city[idcard.substr(0, 2)]) {
      pass = false;
    } else {
      if (idcard.length === 18) {
        idcard = idcard.split("");
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = idcard[i];
          wi = factor[i];
          sum += ai * wi;
        }
        var last = parity[sum % 11];
        if (last.toString() !== idcard[17]) {
          pass = false;
        }
      } else if (idcard.length === 15) {
        pass = true;
      } else {
        pass = false;
      }
    }
    return pass;
  }
};
